<template>
<v-card>
    <v-card-title class="headline">Update Plant Age</v-card-title>
    <v-card-text>
        <v-form ref="editForm" v-model="formValid">
            <v-layout class="dialog-content">
                <v-flex xs12>
                    <v-layout wrap>                       
                        <v-flex xs12>
                            <v-menu v-model="startDateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field :value="formatDate(editData.StartDate)" label="Date From" prepend-icon="event" readonly v-on="on" append-icon="close" @click:append="clearStartDate" :rules="[beforeEndDate]"></v-text-field>
                                </template>
                                <v-date-picker :value="formatDateYMD(editData.StartDate)" :min="crop.PlantingDate" :max="crop.EndDate" @input="updateStartDate"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12>
                            <v-menu v-model="endDateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field :value="formatDate(editData.EndDate)" label="Date To" prepend-icon="event" readonly v-on="on" append-icon="close" @click:append="clearEndDate" :rules="[afterStartDate]"></v-text-field>
                                </template>
                                <v-date-picker :value="formatDateYMD(editData.EndDate)" :min="crop.PlantingDate" :max="crop.EndDate" @input="updateEndDate"></v-date-picker>
                            </v-menu>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-form>
        <v-alert :value="submitError != null" outline type="error">
            <span>{{ submitError }}</span>
        </v-alert>
    </v-card-text>
    <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="submit" :disabled="!formValid" >UPDATE</v-btn>
        <v-btn color="error" @click="cancel">Cancel</v-btn>
    </v-card-actions>
</v-card>
</template>

<script>
import validationRules from "@/helpers/validationrules";
import UtilService from '@/services/utilService.js';
import moment from 'moment';

export default {
    props: {
        crop: {
            required: true,
            type: Object
        },
        item: {
            required: false,
            type: Object
        },
        productTypeID :{
            required: false,
            type: Number
        },
        submitError: {
            required: false,
            type: String
        },
    },
    data() {
        return {
            startDateMenu: false,
            endDateMenu: false,
            rules: validationRules.rules,
            editData: {},
            formValid: false           
        }
    },
    methods: {
        isUserDefinedValue(attributeValueID) {            
            return attributeValueID > 0 && this.attributeValues.find(a => a.AttributeValueID === attributeValueID).UserDefinedValue;
        },
        getUserDefinedValueRules(attributeValueID) {
            let rules = [];

            let attribute = this.attributeValues.find(a => a.AttributeValueID === attributeValueID);

            if (attribute && attribute.UserDefinedType) {
                rules.push(this[attribute.UserDefinedType]);
            }

            return rules;
        },
        integer(v){
            if(v == null || !v.toString().match(/^[0-9]{1,15}$/)){
                return "Please enter a whole positive number";
            }

            return false;
        },
        decimal(v){
            if(v == null || !v.toString().match(/^[0-9]{1,15}.?[0-9]{0,3}$/)){
                return "Please enter a number in the format of XXXXX.XXX";
            }

            return false;
        },
        clearStartDate() {
            this.startDateMenu = true;
            this.$set(this.editData, 'StartDate', null);
            this.startDateMenu = false;
        },
        updateStartDate(v) {
            this.$set(this.editData, 'StartDate', v);
            this.startDateMenu = false;
            if(this.$refs && this.$refs.editForm) {
                this.$refs.editForm.validate();
            }
        },
        clearEndDate() {
            this.endDateMenu = true;
            this.$set(this.editData, 'EndDate', null);
            this.endDateMenu = false;
        },
        updateEndDate(v) {
            this.$set(this.editData, 'EndDate', v);
            this.endDateMenu = false;
            if(this.$refs && this.$refs.editForm) {
                this.$refs.editForm.validate();
            }
        },
        formatDate(v) {
            if (v) {
                return UtilService.formatDateDMY(v, '/');
            }

            return null;
        },
        beforeEndDate(v){
            if(moment(this.editData.EndDate) < moment(v,"DD/MM/YYYY")){

                return "Must be before end date";
            }

            return false;
        },
        afterStartDate(v){
            if((moment(v,"DD/MM/YYYY") < moment(this.editData.StartDate))){
                return "Must be after start date";
            }

            return false;
        },
        formatDateYMD(v) {
            if(v) {
                return UtilService.formatDateYMD(v);
            } 
            return null;
        },
        cancel() {
            this.$emit("cancel");
        },
        submit() {
            this.$emit("submit", this.editData);
        },
    },
}
</script>
